const Backbone = require('backbone');
module.exports = Backbone.View.extend({
	initialize: function() {
		this.$variationsContainer = this.$el.find('.js-variations-container');
		this.$variationsViewMore = this.$el.find('.js-view-more-variations');
		this.variationsMaxHeight = 0;
		this.variationsInitialHeight = 0;
		if (this.$variationsContainer.length) {
			this.variationsMaxHeight = this.$variationsContainer[0].scrollHeight;
			this.variationsInitialHeight = this.$variationsContainer.height();
			if (this.variationsMaxHeight > 220) {
				this.$variationsViewMore.removeClass('dn').addClass('flex');
				this.$variationsViewMore.bind('click', this.viewMoreVariations.bind(this));
			}
		}
	},
	viewMoreVariations: function(e) {
		e.preventDefault();
		const currentText = this.$variationsViewMore
			.find('span')
			.text()
			.toLowerCase();
		if (currentText === 'view more options') {
			this.$variationsContainer.css({ 'max-height': `${this.variationsMaxHeight}px` });
			this.$variationsViewMore.find('span').text('View Less Options');
			this.$variationsViewMore.find('.js-view-less-icon').removeClass('dn');
			this.$variationsViewMore.find('.js-view-more-icon').addClass('dn');
		} else {
			this.$variationsContainer.css({ 'max-height': `${this.variationsInitialHeight}px` });
			this.$variationsViewMore.find('span').text('View More Options');
			this.$variationsViewMore.find('.js-view-less-icon').addClass('dn');
			this.$variationsViewMore.find('.js-view-more-icon').removeClass('dn');
			$('html, body').animate(
				{
					scrollTop: this.$variationsContainer.position().top + 300
				},
				500
			);
		}
	}
});
